import { Component, OnInit } from '@angular/core';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css'],
  providers: [Modal]
})
export class ErrorPopupComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }

  ngOnInit() {
    this.modalData = this.dialog.context.modalData;
  }
  closeClick() {
    this.dialog.context.modalData.next = 'yes';
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/error-popup/error-popup.component.ts